export default theme => ({
    listItem: {
        fontSize: 16,
        lineHeight: '1.5',
        marginBottom: 24,
    },
})